import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class RegisterController {

  constructor(app) {
    this.app = app;
    this.model = {
      name: "",
      email: "",
      password: "",
      avatarRandom: "",
      resource: app.resource
    };
  }
  show(path, model) {
    const userdata = app.userdata;
    const resource = app.resource;
    const avatarRandom = this.avatarRandom();
    this.model = {
      name: userdata.name,
      email: userdata.email,
      password: "",
      avatar: userdata.avatar || avatarRandom,
      resource: resource
    };
    this.popuplate();
  }
  popuplate() {
    const model = this.model;
    const dataBinder = new DataBinder();
    dataBinder.populate("Register", model);

    const swapPage = new SwapPage();
    swapPage.swapPage("Register");
  }
  avatarRandom() {
    const app = this.app;
    const items = app.items;
    if (items.getRandomAvatar) {
      let avatar = items.getRandomAvatar();
      return avatar;
    }
  }
  register(name, email, password, avatar, emailSubscribe) {
    const app = this.app;
    if (!email) {
      app.showToast("Error: Missing email");
      return;
    }
    if (!name) {
      app.showToast("Error: Missing name");
      return;
    }
    if (!password) {
      app.showToast("Error: Missing password");
      return;
    }

    app.showToast("Registering...");
    if (email) email = email.trim();
    let userdata = {
      name: name,
      email: email,
      password: password,
      avatar: avatar,
      emailSubscribe: emailSubscribe
    };
    return app.accountJD.Register(userdata)
      .then(function (data) {
        if (!data || !data.id) return;
        if (data.id) app.userdata.id = data.id;
        if (data.name) app.userdata.name = data.name;
        if (data.email) app.userdata.email = data.email;
        if (data.facebookId) app.userdata.facebookId = data.facebookId;
        if (data.avatar) app.userdata.avatar = data.avatar;
        if (data.emailSubscribe) app.userdata.emailSubscribe = data.emailSubscribe;

        app.navigate("MainMenu");
        app.dataLoaded();
        app.save();
        app.showToast("Login success");

      }.bind(this))
      .catch((e) => {
        app.showToast("Error: Registering - " + e);
      });
  }
}